export default __webpack_public_path__ + "assets/manager-getstarted-laptop-shadow.png";